import { useDispatch, useSelector } from 'react-redux';
import ConsultedEntities from '../ConsultedEntities';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import ChatIcon from '@/public/images/dashboard/chat.svg';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import { getPerformanceDevelopmentConsultationsCard } from '@/store/slices/components/dashboard/service';

function getMostCard(performanceTab) {
  const mostSectionId = 'SearchTrends';
  const mostCardId = 'MostInquiredDevelopments';

  const foundSection = performanceTab.sections.find(
    (section) => section.id === mostSectionId
  );
  const most = (foundSection?.cards || []).find(
    (card) => card.id === mostCardId
  );

  return most;
}

function LeastConsultedDevelopments() {
  // This component doesn't fetch the data
  // "MostConsultedDevelopments" retrieves the most and least consulted developments
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();
  const { tabs } = useSelector((state) => state.DashboardSlice.edition);

  const mostCard = getMostCard(tabs.performance);
  // fallback when most consulted devs is hidden
  const shouldFetch = !mostCard.visible;

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'sortBy',
        value: 'inquiry',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'sortDirection',
        value: 'asc',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <ConsultedEntities
      id="least-consulted-developments"
      title={Trans(translations, 'LeastInquiredDevelopments')}
      stateKey="developmentConsultations"
      stateSubkey="least_consulted"
      entityType="development"
      fetchCallback={(query) => {
        if (!shouldFetch) return;
        dispatch(getPerformanceDevelopmentConsultationsCard({ query }));
      }}
      trackCallback={(element) => track.leastInquiriedDevelopments(element)}
      openTableCallback={handleOpenTable}
      emptyStateChildren={
        <DashboardEmptyStateCard
          icon={ChatIcon}
          title={Trans(
            translations,
            'HereYouWillSeeYourLeastInquiredDevelopments'
          )}
          description={Trans(
            translations,
            'PromotingYourDevelopmentsIsKeyToFindLeads'
          )}
        />
      }
    />
  );
}

export default LeastConsultedDevelopments;
